import React from 'react';
import ReactDOM from 'react-dom/client';
import ClashRoomLanding from './ClashRoomLanding';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClashRoomLanding />
  </React.StrictMode>
);
